export function deriveCameraInitializationPhase(frame, initializedKey) {
    const key = frame.spaceRenderOptions?.camera?.initializationKey;
    if (key === undefined || key === initializedKey)
        return undefined;
    if (!frame.spaceRenderOptions?.camera?.graph?.views.overview) {
        throw new Error('Camera initialization requires an overview view.');
    }
    return {
        patch: {},
        cameraNavigation: { view: 'overview' },
        transitionOptions: { transitionKind: 'instant' },
    };
}
